import { combineReducers } from 'redux';

import search from './reducers/search';
import query from './reducers/query';
import requirementsSet from './reducers/requirements_set';
import session from './reducers/session';
import savedSearches from './reducers/saved_searches';
import ui from './reducers/ui';

const nullReducer = state => ({ ...state });

export default combineReducers({
  paths: nullReducer,
  requirementsSet,
  static: nullReducer,
  savedSearches,
  search,
  session,
  query,
  ui
});
